<template>
  <PopupModal :open="open" @close="close">
    <template #header>
      <p class="textHeadline3">
        {{ t("more.changename.title") }}
      </p>
    </template>
    <template #body>
      <p class="textBody1" v-html="t('more.changename.text')"></p>
      <InputElement
        id="username-input"
        v-model="username"
        class="mt-4"
        type="text"
        max-length="30"
        :required="true"
        :label="t('more.changename.input.label')"
        :show-input-length="true"
      />
    </template>
    <template #footer>
      <div class="flex flex-row justify-center">
        <ButtonElement
          class="mr-4"
          :label="t('more.changename.cancel')"
          :disabled-visible="true"
          @click="close"
        />
        <ButtonElement
          :disabled="!isUsernameValid()"
          :label="t('more.changename.submit')"
          @click="updateUsername"
        />
      </div>
    </template>
  </PopupModal>
</template>
<script setup lang="ts">
import { ref } from "vue";
import PopupModal from "../layout/PopupModal.vue";
import ButtonElement from "../form/ButtonElement.vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "../../../store/v2/user";
import InputElement from "../form/InputElement.vue";
import { updateUser } from "~/api/user";
import { useNotificationStore } from "~/store/v2/notification";

defineProps<{
  open: boolean;
}>();

const { t } = useI18n();
const emit = defineEmits(["close"]);
const userStore = useUserStore();
const username = ref<string>(userStore.getUsername);
const notificationStore = useNotificationStore();

function close() {
  emit("close");
}

function isUsernameValid() {
  const regex = new RegExp("^[a-zA-Z\\s]+$");

  return (
    regex.test(username.value) &&
    username.value.length >= 3 &&
    username.value.length <= 30
  );
}

async function updateUsername() {
  const res = await updateUser({ username: username.value });

  if (res) {
    notificationStore.addNotification(
      Math.random(),
      null,
      t("more.changename.notification.title"),
      t("more.changename.notification.text"),
      false
    );

    userStore.setUsername(username.value);

    close();
  }
}
</script>
